import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Configuration for a ClearData task — resets the payload to a single empty record.
 * All records beyond the first are dropped and processingData is set to {}.
 * Optionally also clears contextData (per-record variables) and flowVariables.
 */
export class ClearDataConfig extends DestinationTaskConfigBase {
	/**
	 * When true, payload.flowVariables is reset to {} (clears all FlowVariable-scoped
	 * values set by SetVariable type=1).
	 * @default undefined (falsy)
	 */
	clearFlowVariables?: boolean;

	/**
	 * When true, record.contextData is reset to {} (clears all RecordVariable-scoped
	 * values set by SetVariable type=0).
	 * @default undefined (falsy)
	 */
	clearRecordVariables?: boolean;

	constructor(init?: Partial<ClearDataConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
